import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PUBLIC.RESERVES.LIST.path,
    exact: true,
    element: <List />,
  },
];

export default routes;
